const StudentEnrollmentsTableColumns = [
    { id: 'student_name', labelAr: 'الطالب', labelEn: 'Student' },
    { id: 'class_name', labelAr: 'الحلقة', labelEn: 'Class', width: 120 },
    { id: 'level_name', labelAr: 'المستوى', labelEn: 'Level', width: 110 },
    { id: 'academic_year_name', labelAr: 'السنة', labelEn: 'Year', width: 120 },
    { id: 'joined_at', labelAr: 'تاريخ الالتحاق', labelEn: 'Joined', width: 110 },
    { id: 'left_at', labelAr: 'تاريخ المغادرة', labelEn: 'Left', width: 110 },
    { id: 'status', labelAr: 'الحالة', labelEn: 'Status', width: 100 },
];

export default StudentEnrollmentsTableColumns;
